const url = 'https://portfolio-backend-c3k1.onrender.com/api'

export default url
